import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncateText',
    pure: false,
    standalone: false
})
export class TruncateTextPipe implements PipeTransform {
    transform(value: string, length: number, htmlFormat = false, truncateClass: string = ''): string {
        if (htmlFormat && value) {
            let htmlValue = document.createElement('html');
            htmlValue.innerHTML = value.replaceAll('</p>', '\n</p>');
            value = htmlValue.innerText.trim();
        }

        if (truncateClass && truncateClass !== '') {
            truncateClass = '.' + truncateClass;
            const classWidth = document.querySelector(truncateClass).clientWidth;
            length = classWidth / 6.5;
            if (truncateClass === '.table-content-row') {
                length = classWidth / (6 * 30);
            }
        }

        if (value && length >= value.length) {
            return value;
        } else if (value) {
            return value.substring(0, length) + '..';
        }
        return '';
    }
}
